"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useCreateFolder: true,
  useDeleteFolder: true,
  useUploadDocument: true,
  useListDocuments: true,
  useReadDocument: true,
  useDeleteDocument: true,
  useRemoveDocument: true,
  useCreateDocumentAccess: true,
  useUpdateDocumentAccess: true,
  useDeleteDocumentAccess: true,
  useSecureDocumentsContext: true,
  useDownloadDocument: true,
  useSecureDocumentsWidget: true
};
Object.defineProperty(exports, "useCreateFolder", {
  enumerable: true,
  get: function get() {
    return _useCreateFolder.default;
  }
});
Object.defineProperty(exports, "useDeleteFolder", {
  enumerable: true,
  get: function get() {
    return _useDeleteFolder.default;
  }
});
Object.defineProperty(exports, "useUploadDocument", {
  enumerable: true,
  get: function get() {
    return _useUploadDocument.default;
  }
});
Object.defineProperty(exports, "useListDocuments", {
  enumerable: true,
  get: function get() {
    return _useListDocuments.default;
  }
});
Object.defineProperty(exports, "useReadDocument", {
  enumerable: true,
  get: function get() {
    return _useReadDocument.default;
  }
});
Object.defineProperty(exports, "useDeleteDocument", {
  enumerable: true,
  get: function get() {
    return _useDeleteDocument.default;
  }
});
Object.defineProperty(exports, "useRemoveDocument", {
  enumerable: true,
  get: function get() {
    return _useRemoveDocument.default;
  }
});
Object.defineProperty(exports, "useCreateDocumentAccess", {
  enumerable: true,
  get: function get() {
    return _useCreateDocumentAccess.default;
  }
});
Object.defineProperty(exports, "useUpdateDocumentAccess", {
  enumerable: true,
  get: function get() {
    return _useUpdateDocumentAccess.default;
  }
});
Object.defineProperty(exports, "useDeleteDocumentAccess", {
  enumerable: true,
  get: function get() {
    return _useDeleteDocumentAccess.default;
  }
});
Object.defineProperty(exports, "useSecureDocumentsContext", {
  enumerable: true,
  get: function get() {
    return _useSecureDocumentsContext.default;
  }
});
Object.defineProperty(exports, "useDownloadDocument", {
  enumerable: true,
  get: function get() {
    return _useDownloadDocument.default;
  }
});
Object.defineProperty(exports, "useSecureDocumentsWidget", {
  enumerable: true,
  get: function get() {
    return _useSecureDocumentsWidget.default;
  }
});

var _useCreateFolder = _interopRequireWildcard(require("./useCreateFolder"));

Object.keys(_useCreateFolder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useCreateFolder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCreateFolder[key];
    }
  });
});

var _useDeleteFolder = _interopRequireWildcard(require("./useDeleteFolder"));

Object.keys(_useDeleteFolder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDeleteFolder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDeleteFolder[key];
    }
  });
});

var _useUploadDocument = _interopRequireWildcard(require("./useUploadDocument"));

Object.keys(_useUploadDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useUploadDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUploadDocument[key];
    }
  });
});

var _useListDocuments = _interopRequireWildcard(require("./useListDocuments"));

Object.keys(_useListDocuments).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useListDocuments[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useListDocuments[key];
    }
  });
});

var _useReadDocument = _interopRequireWildcard(require("./useReadDocument"));

Object.keys(_useReadDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useReadDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useReadDocument[key];
    }
  });
});

var _useDeleteDocument = _interopRequireWildcard(require("./useDeleteDocument"));

Object.keys(_useDeleteDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDeleteDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDeleteDocument[key];
    }
  });
});

var _useRemoveDocument = _interopRequireWildcard(require("./useRemoveDocument"));

Object.keys(_useRemoveDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useRemoveDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useRemoveDocument[key];
    }
  });
});

var _useCreateDocumentAccess = _interopRequireWildcard(require("./useCreateDocumentAccess"));

Object.keys(_useCreateDocumentAccess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useCreateDocumentAccess[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCreateDocumentAccess[key];
    }
  });
});

var _useUpdateDocumentAccess = _interopRequireWildcard(require("./useUpdateDocumentAccess"));

Object.keys(_useUpdateDocumentAccess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useUpdateDocumentAccess[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUpdateDocumentAccess[key];
    }
  });
});

var _useDeleteDocumentAccess = _interopRequireWildcard(require("./useDeleteDocumentAccess"));

Object.keys(_useDeleteDocumentAccess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDeleteDocumentAccess[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDeleteDocumentAccess[key];
    }
  });
});

var _useSecureDocumentsContext = _interopRequireWildcard(require("./useSecureDocumentsContext"));

Object.keys(_useSecureDocumentsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useSecureDocumentsContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useSecureDocumentsContext[key];
    }
  });
});

var _useDownloadDocument = _interopRequireWildcard(require("./useDownloadDocument"));

Object.keys(_useDownloadDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDownloadDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDownloadDocument[key];
    }
  });
});

var _useSecureDocumentsWidget = _interopRequireWildcard(require("./useSecureDocumentsWidget"));

Object.keys(_useSecureDocumentsWidget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useSecureDocumentsWidget[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useSecureDocumentsWidget[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBRUE7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFTQTs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUVBOztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBRUE7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFFQTs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUVBOztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBRUE7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFJQTs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUVBOztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBSUE7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFFQTs7QUFDQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUVBOztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IGFzIHVzZUNyZWF0ZUZvbGRlciB9IGZyb20gJy4vdXNlQ3JlYXRlRm9sZGVyJztcbmV4cG9ydCAqIGZyb20gJy4vdXNlQ3JlYXRlRm9sZGVyJztcblxuZXhwb3J0IHsgZGVmYXVsdCBhcyB1c2VEZWxldGVGb2xkZXIgfSBmcm9tICcuL3VzZURlbGV0ZUZvbGRlcic7XG5leHBvcnQgKiBmcm9tICcuL3VzZURlbGV0ZUZvbGRlcic7XG5cbi8vIFRPRE86IHVzZUNyZWF0ZUZvbGRlckFjY2Vzc1xuLy8gVE9ETzogdXNlVmFsaWRhdGVGb2xkZXJBY2Nlc3Ncbi8vIFRPRE86IHVzZVVwZGF0ZUZvbGRlckFjY2Vzc1xuLy8gVE9ETzogdXNlRGVsZXRlRm9sZGVyQWNjZXNzXG5cbi8vIFRPRE86IHVzZUNyZWF0ZURvY3VtZW50XG5cbmV4cG9ydCB7IGRlZmF1bHQgYXMgdXNlVXBsb2FkRG9jdW1lbnQgfSBmcm9tICcuL3VzZVVwbG9hZERvY3VtZW50JztcbmV4cG9ydCAqIGZyb20gJy4vdXNlVXBsb2FkRG9jdW1lbnQnO1xuXG5leHBvcnQgeyBkZWZhdWx0IGFzIHVzZUxpc3REb2N1bWVudHMgfSBmcm9tICcuL3VzZUxpc3REb2N1bWVudHMnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VMaXN0RG9jdW1lbnRzJztcblxuZXhwb3J0IHsgZGVmYXVsdCBhcyB1c2VSZWFkRG9jdW1lbnQgfSBmcm9tICcuL3VzZVJlYWREb2N1bWVudCc7XG5leHBvcnQgKiBmcm9tICcuL3VzZVJlYWREb2N1bWVudCc7XG5cbmV4cG9ydCB7IGRlZmF1bHQgYXMgdXNlRGVsZXRlRG9jdW1lbnQgfSBmcm9tICcuL3VzZURlbGV0ZURvY3VtZW50JztcbmV4cG9ydCAqIGZyb20gJy4vdXNlRGVsZXRlRG9jdW1lbnQnO1xuXG5leHBvcnQgeyBkZWZhdWx0IGFzIHVzZVJlbW92ZURvY3VtZW50IH0gZnJvbSAnLi91c2VSZW1vdmVEb2N1bWVudCc7XG5leHBvcnQgKiBmcm9tICcuL3VzZVJlbW92ZURvY3VtZW50JztcblxuZXhwb3J0IHsgZGVmYXVsdCBhcyB1c2VDcmVhdGVEb2N1bWVudEFjY2VzcyB9IGZyb20gJy4vdXNlQ3JlYXRlRG9jdW1lbnRBY2Nlc3MnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VDcmVhdGVEb2N1bWVudEFjY2Vzcyc7XG5cbi8vIFRPRE86IHVzZVZhbGlkYXRlRG9jdW1lbnRBY2Nlc3NcblxuZXhwb3J0IHsgZGVmYXVsdCBhcyB1c2VVcGRhdGVEb2N1bWVudEFjY2VzcyB9IGZyb20gJy4vdXNlVXBkYXRlRG9jdW1lbnRBY2Nlc3MnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VVcGRhdGVEb2N1bWVudEFjY2Vzcyc7XG5cbmV4cG9ydCB7IGRlZmF1bHQgYXMgdXNlRGVsZXRlRG9jdW1lbnRBY2Nlc3MgfSBmcm9tICcuL3VzZURlbGV0ZURvY3VtZW50QWNjZXNzJztcbmV4cG9ydCAqIGZyb20gJy4vdXNlRGVsZXRlRG9jdW1lbnRBY2Nlc3MnO1xuXG4vLyA9PSBSZWFjdCBTcGVjaWZpYyA9PVxuXG5leHBvcnQgeyBkZWZhdWx0IGFzIHVzZVNlY3VyZURvY3VtZW50c0NvbnRleHQgfSBmcm9tICcuL3VzZVNlY3VyZURvY3VtZW50c0NvbnRleHQnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VTZWN1cmVEb2N1bWVudHNDb250ZXh0JztcblxuZXhwb3J0IHsgZGVmYXVsdCBhcyB1c2VEb3dubG9hZERvY3VtZW50IH0gZnJvbSAnLi91c2VEb3dubG9hZERvY3VtZW50JztcbmV4cG9ydCAqIGZyb20gJy4vdXNlRG93bmxvYWREb2N1bWVudCc7XG5cbmV4cG9ydCB7IGRlZmF1bHQgYXMgdXNlU2VjdXJlRG9jdW1lbnRzV2lkZ2V0IH0gZnJvbSAnLi91c2VTZWN1cmVEb2N1bWVudHNXaWRnZXQnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VTZWN1cmVEb2N1bWVudHNXaWRnZXQnO1xuIl19


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/securedocuments-sdk-js/dist/react/hooks/index.js
// module id = 1795
// module chunks = 0